import React from 'react';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import './kvkk.css';

const KVKK = () => {
  return (
    <>
        <Header />
        <div className='corporate-kvkk-container'>
            {/* Üst Banner Alanı */}
            <div className='corporate-kvkk-banner'>
                <h1 className='corporate-kvkk-banner-title'>KVKK Aydınlatma Metni</h1>
                <p className='corporate-kvkk-subtitle'>Kişisel Verilerin Korunması Kanunu Kapsamında Bilgilendirme</p>
            </div>

            {/* İçerik Kartları Izgarası */}
            <div className='corporate-kvkk-grid'>
                
                <div className='corporate-kvkk-box'>
                   <h2 className='corporate-kvkk-box-title'>KİŞİSEL VERİLERİN TOPLANMA YÖNTEMLERİ</h2>
                   <p className='corporate-kvkk-box-intro'>Kişisel verileriniz;</p>
                   <ul className='corporate-kvkk-list'>
                       <li>Web sitemiz ve mobil uygulamamız üzerinden,</li>
                       <li>Sosyal medya kanallarımız üzerinden,</li>
                       <li>Etkinlik ve organizasyonlarımız sırasında,</li>
                       <li>Fiziksel formlar aracılığıyla,</li>
                   </ul>
                </div>

                <div className='corporate-kvkk-box'>
                   <h2 className='corporate-kvkk-box-title'>İŞLENEN KİŞİSEL VERİLER</h2>
                   <p className='corporate-kvkk-box-intro'>Kişisel verileriniz;</p>
                   <ul className='corporate-kvkk-list'>
                       <li>Kimlik Bilgileri (Ad, soyad, T.C. kimlik no, doğum tarihi vb.)</li>
                       <li>İletişim Bilgileri (Adres, telefon, e-posta vb.)</li>
                       <li>Eğitim Bilgileri (Okul, bölüm, mezuniyet durumu vb.)</li>
                       <li>Mesleki Deneyim (İş geçmişi, pozisyon, referanslar vb.)</li>
                       <li>Görsel ve İşitsel Kayıtlar</li>
                   </ul>
                </div>

                <div className='corporate-kvkk-box'>
                   <h2 className='corporate-kvkk-box-title'>İŞLENME AMAÇLARI</h2>
                   <p className='corporate-kvkk-box-intro'>Kişisel verileriniz;</p>
                   <ul className='corporate-kvkk-list'>
                       <li>Dernek faaliyetleri hakkında bilgilendirme,</li>
                       <li>Etkinlik ve organizasyon düzenlenmesi,</li>
                       <li>Eğitim ve kariyer planlaması desteği,</li>
                       <li>Yasal yükümlülüklerin yerine getirilmesi,</li>
                       <li>İletişim faaliyetlerinin yürütülmesi amacıyla işlenmektedir.</li>
                   </ul>
                </div>

                <div className='corporate-kvkk-box'>
                   <h2 className='corporate-kvkk-box-title'>İŞLENEN KİŞİSEL VERİLERİN AKTARILMASI</h2>
                   <p className='corporate-kvkk-box-intro'>Kişisel verileriniz;</p>
                   <ul className='corporate-kvkk-list'>
                       <li>Yasal yükümlülükler kapsamında yetkili kamu kurumlarıyla,</li>
                   </ul>
                </div>

                <div className='corporate-kvkk-box'>
                   <h2 className='corporate-kvkk-box-title'>VERİ SAHİBİNİN HAKLARI</h2>
                   <p className='corporate-kvkk-box-intro'>KVK Kanunu'nun 11. maddesi uyarınca veri sahipleri;</p>
                   <ul className='corporate-kvkk-list'>
                       <li>Kişisel veri işlenip işlenmediğini öğrenme,</li>
                       <li>İşlenen verilere ilişkin bilgi talep etme,</li>
                       <li>İşlenme amacını ve uygun kullanılıp kullanılmadığını öğrenme,</li>
                       <li>Eksik veya yanlış işleme durumunda düzeltme isteme,</li>
                       <li>Verilerin silinmesini veya yok edilmesini isteme hakkına sahiptir.</li>
                   </ul>
                </div>

                <div className='corporate-kvkk-box'>
                   <h2 className='corporate-kvkk-box-title'>GÜVENLİK ÖNLEMLERİ</h2>
                   <p className='corporate-kvkk-box-intro'>Kişisel verileriniz için;</p>
                   <ul className='corporate-kvkk-list'>
                       <li>Gerekli tüm teknik ve idari güvenlik önlemleri alınmaktadır,</li>
                       <li>Veri güvenliği için periyodik denetimler yapılmaktadır,</li>
                       <li>Çalışanlarımız veri gizliliği ve güvenliği konusunda eğitilmektedir.</li>
                   </ul>
                </div>

            </div>
        </div>
        <Footer />
    </>
  );
};

export default KVKK;